import FeaturedBlogContent from './FeaturedBlogContent'

export default FeaturedBlogContent
